import { Injectable } from '@angular/core';
import { ApiQuery } from '@kinet-open-network/client/core/api-client';
import { ProductPricesService } from '@kinet-open-network/client/product-prices/data-access';
import {
  downloadBlob,
  getFilenameFromHeaders,
} from '@kinet-open-network/client/shared/util';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppProductPricesService extends ProductPricesService {
  async exportForOnix(query?: ApiQuery | null, filename?: string) {
    const response = await firstValueFrom(
      this.http.get(`${this.endpoint}/export-for-onix`, {
        params: this.apiQueryToHttpParams(query),
        responseType: 'blob',
        observe: 'response',
      }),
    );

    const blob = response.body as Blob;

    if (filename === undefined) {
      filename = getFilenameFromHeaders(response.headers);
    }

    return downloadBlob(
      blob,
      filename ??
        `export-${this.modelClass.name.toLowerCase()}s-${new Date().getTime()}.xlsx`,
    );
  }
}
